export function accordion() {
    const tabs = document.querySelectorAll('.accordion-title');

    tabs.forEach((el) => {
        el.addEventListener('click', e => {
            let tab = e.target.closest('.accordion-contents'),
                wrapper = tab.querySelector('.accordion-content-wrapper'),
                content = tab.querySelector('.accordion-content');

            wrapper.style.maxHeight = tab.classList.contains('active') ? 0 : content.offsetHeight + 'px';
            tab.classList.toggle('active');
        });
    });
}
